import { branding, Colour_Tournament } from "./Utils";

export class TwoSubstitution {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "TwoSubstitution";
    this.scene = "TwoSubstitution";
    this.data = [];
    this.page = 7072;
  }

  async preview({ options }) {
    this.onAir = false;
    let xml = await this.getVizPage({ page: this.page }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml = Colour_Tournament({ game: options.game, xml });
      xml = branding({ game: options.game, team: options.team, xml });

      xml.payload.field.find((item) => {
        return item.attr.name === "0001";
      }).value = "2";

      xml.payload.field.find((item) => {
        return item.attr.name === "101";
      }).value = options?.subs?.[0]?.players?.[0]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = options?.subs?.[0]?.players?.[0]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = options?.subs?.[1]?.players?.[0]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "104";
      }).value = options?.subs?.[1]?.players?.[0]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "201";
      }).value = options?.subs?.[0]?.players?.[1]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "202";
      }).value = options?.subs?.[0]?.players?.[1]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "203";
      }).value = options?.subs?.[1]?.players?.[1]?.squad?.shirt_number;

      xml.payload.field.find((item) => {
        return item.attr.name === "204";
      }).value = options?.subs?.[1]?.players?.[1]?.squad?.player?.last_name;

      xml.payload.field.find((item) => {
        return item.attr.name === "300.active";
      }).value = "1";
      debugger;
      xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = options.hia || options.reversal ? "HIA" : "Interchange";

      xml.payload.field.find((item) => {
        return item.attr.name === "301";
      }).value = options.hia
        ? "sub"
        : options.reversal
          ? "reversal"
          : parseInt(options.made + 2) + "/" + options.total;

      await this.updateVizPage({ page: this.page, data: xml }).catch((err) => {
        console.log(err);
      });

      await this.sendPreview("page:read " + this.page);
    }
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }

  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  update({ options }) {}
}
